'use client';

import React from 'react';
import Link from '@/components/AppLink';
import { ArrowUpRight } from 'lucide-react';
import { formatDisplayText } from '../../../utils/textUtils';

interface Subtopic {
  _id: string;
  subtopic_name: string;
}

interface TestSubtopicCardProps {
  subtopic: Subtopic;
  index?: number;
}

export default function TestSubtopicCard({ subtopic, index = 0 }: TestSubtopicCardProps) {
  return (
    <Link
      href={`/onlinetest/${encodeURIComponent(subtopic.subtopic_name)}`}
      className="group relative bg-[var(--study-surface)] rounded-2xl overflow-hidden cursor-pointer transition-[color,background-color,border-color,opacity,transform] duration-300 flex flex-col border border-[var(--study-border)] hover:border-[rgba(15,110,86,0.36)] shadow-lg hover:shadow-2xl min-h-[200px] text-left w-full"
      aria-label={`Start online test for ${formatDisplayText(subtopic.subtopic_name)}`}
    >
      <div className="absolute inset-0 bg-gradient-to-br from-[rgba(15,110,86,0.08)] via-transparent to-[rgba(216,154,58,0.10)] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

      <div className="relative p-6 flex flex-col flex-grow">
        <div className="absolute top-4 right-4 text-5xl font-black text-[var(--study-primary)] opacity-10 group-hover:opacity-15 transition-opacity">
          {String(index + 1).padStart(2, '0')}
        </div>
        
        <h3 className="text-xl font-bold mb-auto line-clamp-3 leading-snug relative z-10 pr-8 text-[var(--study-text)]">
          {formatDisplayText(subtopic.subtopic_name)}
        </h3>

        <div className="mt-5 flex justify-between items-center relative z-10">
          <span className="study-link text-sm">
            Start Test
          </span>
          <div className="w-10 h-10 bg-[var(--study-primary)] group-hover:bg-[var(--study-primary-hover)] text-white flex items-center justify-center transition-[color,background-color,border-color,opacity,transform] duration-300 group-hover:rotate-45 rounded-lg">
            <ArrowUpRight className="w-5 h-5 transition-[color,background-color,border-color,opacity,transform] duration-300" aria-hidden="true" />
          </div>
        </div>
      </div>
    </Link>
  );
}

